import { cn } from '@virginexperiencedays/tailwind';
import { Image } from '../../layout/Image';
import type { HTMLAttributes } from 'react';

export type Props = {
  title: string;
  image: { src: string; alt?: string };
  onClick?: () => void;
  ariaLabel?: string;
};

export const CollectionChoiceCard = ({
  title,
  image,
  onClick,
  ariaLabel,
  className,
  ...props
}: Readonly<Props> & HTMLAttributes<HTMLDivElement>) => {
  const cardContent = (
    <div className={cn('flex w-full flex-col gap-2', className)} {...props}>
      <div className="relative aspect-square overflow-hidden rounded-md">
        <Image
          src={image.src}
          alt={image?.alt ?? title}
          fill
          className="h-full w-full object-cover"
        />
      </div>
      <p className="line-clamp-3 text-left text-sm font-medium leading-5">{title}</p>
    </div>
  );
  return onClick ? (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      className="background-none border-none p-0 outline-none"
    >
      {cardContent}
    </button>
  ) : (
    cardContent
  );
};
